import React from "react";
import ProductCard from "../ProductCard/ProductCard";
import "./CategorySection.css";

const CategorySection = ({ category }) => {
  return (
    <section id={category.id} className="category-section">
      <div className="container">
        <h2 className="category-title">{category.title}</h2>
        <div className="products-list">
          {category.items.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              categoryId={category.id}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
